import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { LastTradedStore } from './lastTraded.types';

const useLastTradedStoreBase = create<LastTradedStore>()(
  devtools(
    set => ({
      state: {
        lastTradedPrice: {},
        subscribedSymbols: [],
      },
      actions: {
        updateLastTradedPrices: prices =>
          set(
            store => ({
              state: {
                ...store.state,
                lastTradedPrice: { ...store.state.lastTradedPrice, ...prices },
              },
            }),
            false,
            'updateLastTradedPrices'
          ),
        setSubscribedSymbols: symbols =>
          set(
            store => ({
              state: {
                ...store.state,
                subscribedSymbols: symbols,
              },
            }),
            false,
            'setSubscribedSymbols'
          ),
      },
    }),
    {
      name: 'LastTradedStore',
    }
  )
);

export { useLastTradedStoreBase };
